export default function LoadingButton(theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: 15, // Aumentar tamanho da fonte do botão
          backgroundColor: theme.palette.primary.main, // Define a cor personalizada
          '&:hover': {
            backgroundColor: theme.palette.primary.dark, // Cor mais escura ao passar o mouse
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.primary.light, // Cor personalizada do botão desabilitado
            color: '#ffffff', // Cor do texto do botão desabilitado
            opacity: 0.5, // Opacidade do botão desabilitado
          },
        },
        loadingIndicator: {
          color: theme.palette.primary.darker, // Define a cor do indicador de loading
        },
        loadingIndicatorCenter: {
          left: '50%',
          transform: 'translateX(-50%)',
        },
      },
    },
  };
}
